// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3u9iz","right":"styles_right__2VDiD"};